(function () {
  angular
    .module('specsguardApp')
    .component('sgAreaStateClusterTable', {
      // @ts-ignore
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-area-state-cluster-table/sg-area-state-cluster-table.html',
      controller: 'sgAreaStateClusterTableCtrl',
      controllerAs: '$sgAreaStateClusterTableCtrl',
      bindings: {
        cluster: '<',
        building: '<',
        canWrite: '<',
        canDelete: '<',
        selectArea: '&',
        removeArea: '&',
        listIndex: '<',
        doItemActionFor: '&',
        submitAreaValue: '&',
        dragAndDrop: '<',
        dragAndDropCallback: '&',
        addArea: '&'
      }
    });
})();
